import Vue from 'vue'
import Router from 'vue-router'
import main from '../pages/main'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: '首页',
    component: (resolve => require([`@/pages/main`], resolve))
  }, {
    path: '/share',
    name: '分享',
    component: (resolve => require([`@/pages/share/share.vue`], resolve))
  },
  , {
    path: '/shareWnq',
    name: '分享',
    component: (resolve => require([`@/pages/share/shareWnq.vue`], resolve))
  },

  {
    path: '/testShare',
    name: '分享',
    component: (resolve => require([`@/pages/testShare/testShare.vue`], resolve))
  },
  {
    path: '/fleetMap',
    name: '车队地图',
    component: (resolve => require([`@/pages/fleetMap/fleetMap.vue`], resolve))
  },
  {
    path: '/selectFleetMap',
    name: '成员地图',
    component: (resolve => require([`@/pages/selectFleetMap/selectFleetMap.vue`], resolve))
  },
  {
    path: '/transportMap',
    name: '零担地图',
    component: (resolve => require([`@/pages/transportMap/transportMap.vue`], resolve))
  },
  {
    path: '/privacy',
    name: '货先生隐私政策',
    meta: {
      title: '货先生隐私政策'
    },
    component: (resolve => require([`@/pages/privacy/privacy.vue`], resolve))
    },
    {
    path: '/privacyn',
    name: '货先生隐私政策',
    meta: {
      title: '货先生隐私政策'
    },
    component: (resolve => require([`@/pages/privacy/privacyn.vue`], resolve))
    },
    {
      path: '/weappPrivacy',
      name: '找卡车隐私政策',
      meta: {
        title: '找卡车隐私政策'
      },
      component: (resolve => require([`@/pages/weapp/weappPrivacy.vue`], resolve))
    },
    {
      path: '/weappService',
      name: '找卡车用户服务协议',
      meta: {
        title: '找卡车用户服务协议'
      },
      component: (resolve => require([`@/pages/weapp/weappService.vue`], resolve))
    },
  {
    path: '/service',
    name: '货先生用户服务协议',
    meta: {
      title: '货先生用户服务协议'
    },
    component: (resolve => require([`@/pages/service/service.vue`], resolve))
  },
  {
    path: '/authorization',
    name: '货先生用户授权协议',
    meta: {
      title: '货先生用户授权协议'
    },
    component: (resolve => require([`@/pages/authorization/authorization.vue`], resolve))
  }
    ,
  {
    path: '/ChinaTravel',
    name: '点亮中国行',
    meta: {
      title: '点亮中国行'
    },
    component: (resolve => require([`@/pages/ChinaTravel/ChinaTravel.vue`], resolve))
  },

  {
    path: '/knowledgeBase',
    name: '知识库',
    meta: {
      title: '知识库'
    },
    component: (resolve => require([`@/pages/knowledgeBase/knowledgeBase.vue`], resolve))
    },
    {
      path: '/iframe',
      name: '知识库',
      meta: {
        title: '知识库'
      },
      component: (resolve => require([`@/pages/knowledgeBase/iframe.vue`], resolve))
    },

  {
    path: '/fleetReport',
    name: '车队报表',
    meta: {
      title: '年度账单'
    },
    component: (resolve => require([`@/pages/fleetReport/fleetReport.vue`], resolve))
  },
  {
    path: '/userHistoryLocation',
    name: '用户轨迹',
    meta: {
      title: '用户轨迹'
    },
    component: (resolve => require([`@/pages/userHistoryLocation/index.vue`], resolve))
  }
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js